import * as yup from 'yup'
import { ERROR_MESSAGE } from 'utils/globalConstant'

export const validationSchema = yup.object({
  username: yup.string().required(ERROR_MESSAGE.required),
  password: yup.string().required(ERROR_MESSAGE.required),
})
